enum AppRole {
  UserAdmin = "UserAdmin",
  MasterDataAdmin = "MasterDataAdmin",
  PublicationAdmin = "PublictionAdmin",
  ExhibitionAdmin = "ExhibitionAdmin",
}

export default AppRole;
